import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PopUp } from "../../Info";
import { Button } from "../../Controls";
import s from "./style.scss";
const AlreadyCompletedSignup = ({ isOpen, setIsOpen }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const handleSignIn = () => {
        setIsOpen(false);
        navigate("/signin");
    };
    return (React.createElement(PopUp, { style: s.alreadyCompletedPopup, isOpen: isOpen, allowClose: true, toggle: () => setIsOpen(false) },
        React.createElement("div", { className: s.popupBody },
            React.createElement("div", { className: s.title }, t("alreadyCompletedSignup")),
            React.createElement("div", { className: s.message }, t("alreadyCompletedSignupMessage")),
            React.createElement(Button, { primary: true, text: t("signIn"), onClick: handleSignIn, style: s.signInButton }))));
};
export default AlreadyCompletedSignup;
